import { QualifyingQuestion } from "@/types/jobAdsTypes";

export interface CreateAdModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export interface StepProps {
  onNext: () => void;
  isProcessing?: boolean;
}

export interface Tag {
  value: string;
  label: string;
}

export interface AdFormData {
  jobDescription: string;
  descriptionOfRoleRaw: string; // Raw text version without HTML formatting
  shortJobDescription: string;
  roleTitle: string;
  selectedTags: string[];
  salary: string;
  location: string;
  isRemote: boolean;
  experience: string;
  formOfEmployment: string;
  qualifyingQuestions: QualifyingQuestion[];
  selectedBenefits: string[];
  swedishLevel: string;
  englishLevel: string;
  driversLicense: string;
  payTransparency: boolean;
}

export interface PreviewDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  formData: AdFormData;
  businessProfile: any; // Replace with proper type from your context
  onSubmit: () => void;
  isProcessing: boolean;
}

export interface EditDescriptionDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  description: string;
  onSave: (description: string) => void;
}

// Validation constants and helpers for the advanced editing stage
export const DESCRIPTION_MIN_CHARS = 250;
export const DESCRIPTION_MAX_CHARS = 1000;

export const validateDescription = (html: string): { isValid: boolean; error?: string } => {
  // Convert HTML to plain text for character counting
  const text = html.replace(/<[^>]*>/g, '').trim();
  const charCount = text.length;
  
  if (charCount < DESCRIPTION_MIN_CHARS) {
    return {
      isValid: false,
      error: `Beskrivningen måste vara minst ${DESCRIPTION_MIN_CHARS} tecken (nuvarande: ${charCount})`
    };
  }
  
  if (charCount > DESCRIPTION_MAX_CHARS) {
    return {
      isValid: false,
      error: `Beskrivningen får vara max ${DESCRIPTION_MAX_CHARS} tecken (nuvarande: ${charCount})`
    };
  }
  
  return { isValid: true };
};

export const getPlainTextFromHtml = (html: string): string => {
  return html.replace(/<[^>]*>/g, '').trim();
};

// Validation for initial draft (no character limits)
export const validateInitialDraft = (text: string): { isValid: boolean; error?: string } => {
  const trimmedText = text.trim();
  
  if (trimmedText.length === 0) {
    return {
      isValid: false,
      error: "Beskriv kort vad ni söker för att AI:n ska kunna skapa ett utkast"
    };
  }
  
  if (trimmedText.length < 10) {
    return {
      isValid: false,
      error: "Beskrivningen är för kort för att AI:n ska kunna skapa ett bra utkast"
    };
  }
  
  return { isValid: true };
}; 